import { USER_SCREEN } from "../apiConstant";
import BaseApi from "../baseApi";

class UserScreenApi extends BaseApi {
  constructor() {
    super();
    this.BASE_URL = process.env.REACT_APP_AUTHENTICATION_API_URL || "";
    this.$axiosInstance = this.initAxiosInstance();
  }

  updateScreen(body) {
    return this.post(`${USER_SCREEN}/update`, body);
  }
}
export default UserScreenApi;
